import { Grid, Typography } from '@mui/material'
import theme from '../../theme'
import { Link } from 'react-router-dom'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { RoleTable } from './RoleForm'
import { AddRoleData } from '../../static-models/RoleFormData'

export function Role() {


  return (
    <>
      <Grid container display={'flex'} flexDirection={'column'} width={'100%'}>
        <Grid
          item
          width={'100%'}
          height={'6.25rem'}
          display={'flex'}
          alignItems={'center'}
          borderBottom={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
          mb={4}
          sx={{ background: theme.color?.background }}
        >
          <Grid item display={'flex'} alignItems={'center'} px={4} gap={2}>
            <Link to='/admin'>
              <ArrowBackIosIcon />
            </Link>{' '}
            <Typography
              variant='h6'
              sx={{ color: theme?.color?.primary,fontFamily:theme.font?.fontFamily.primary, fontWeight: '600' }}
            >
              Role Management
            </Typography>
          </Grid>
        </Grid>

        <Grid item px={'1rem'} width={'90%'}>
          <RoleTable
            initialFormData={AddRoleData}
          />
        </Grid>
      </Grid>
      
    </>
  )
}
